const $inject = [];

const appInsightsService = function () {
  let service = {};

  service.trackPageView = trackPageView;
  service.trackEvent = trackEvent;
  service.trackError = trackError;

  function trackPageView(pageName) {
    appInsights.trackPageView(pageName);
  }

  function trackEvent(event, data) {
    appInsights.trackEvent(event, data);
  }

  function trackError(error) {
    appInsights.trackException(error);
  }

  return service;
};

appInsightsService.$inject = $inject;

export default appInsightsService;


// WEBPACK FOOTER //
// ./src/services/appInsightsService.js